"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@mapmaker/core");
const react_1 = require("react");
const MapmakerApi_1 = require("../../../../../client/MapmakerApi");
const useProjectState_1 = require("../../../useProjectState");
const useSuggestion_1 = require("./useSuggestion");
const useSuggestionAcceptance_1 = require("./useSuggestionAcceptance");
/**
 * Convenient way to get data about the opening suggestions in the current project.
 */
function useProjectOpeningSuggestions({ includeHidden = false, includeCurrentlyInMap = false, includeSubmitted = true, openingId, suggesterId, } = {}) {
    const file = (0, useProjectState_1.useProjectFile)();
    const isOwner = file.viewerPolicy === MapmakerApi_1.MapmakerFileViewerPolicy.Owner;
    const openingSuggestions = (0, react_1.useMemo)(() => file.openingSuggestions
        .filter(suggestion => {
        if (openingId && suggestion.openingId !== openingId) {
            return false;
        }
        if (suggesterId && suggestion.suggesterId !== suggesterId) {
            return false;
        }
        if (includeHidden === false &&
            suggestion.status === MapmakerApi_1.OpeningSuggestionStatus.Hidden) {
            return false;
        }
        if (includeSubmitted === false &&
            suggestion.status === MapmakerApi_1.OpeningSuggestionStatus.Submitted) {
            return false;
        }
        if (includeCurrentlyInMap === false) {
            const openingInput = (0, core_1.getOpeningInput)(file, suggestion.openingId);
            const inclusionStatus = (0, useSuggestionAcceptance_1.getSuggestionAcceptance)(suggestion, openingInput).inclusionStatus;
            if (inclusionStatus === "all-in-map-exact") {
                return false;
            }
        }
        return true;
    })
        .sort(isOwner ? useSuggestion_1.compareSuggestionsSubmitted : useSuggestion_1.compareSuggestionsModified), [
        file.openingSuggestions,
        includeHidden,
        includeCurrentlyInMap,
        includeSubmitted,
        suggesterId,
        openingId,
        isOwner,
    ]);
    return openingSuggestions;
}
exports.default = useProjectOpeningSuggestions;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlT3BlbmluZ1N1Z2dlc3Rpb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvcHJvamVjdC9mZWF0dXJlcy9vcGVuaW5nL3N1Z2dlc3Rpb25zL3VzZU9wZW5pbmdTdWdnZXN0aW9ucy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLHlDQUFpRDtBQUNqRCxpQ0FBZ0M7QUFDaEMsbUVBRzJDO0FBQzNDLDhEQUEwRDtBQUMxRCxtREFHeUI7QUFDekIsdUVBQW9FO0FBV3BFOztHQUVHO0FBQ0gsU0FBd0IsNEJBQTRCLENBQUMsRUFDbkQsYUFBYSxHQUFHLEtBQUssRUFDckIscUJBQXFCLEdBQUcsS0FBSyxFQUM3QixnQkFBZ0IsR0FBRyxJQUFJLEVBQ3ZCLFNBQVMsRUFDVCxXQUFXLE1BQzBCLEVBQUU7SUFDdkMsTUFBTSxJQUFJLEdBQUcsSUFBQSxnQ0FBYyxHQUFFLENBQUM7SUFDOUIsTUFBTSxPQUFPLEdBQUcsSUFBSSxDQUFDLFlBQVksS0FBSyxzQ0FBd0IsQ0FBQyxLQUFLLENBQUM7SUFDckUsTUFBTSxrQkFBa0IsR0FBRyxJQUFBLGVBQU8sRUFDaEMsR0FBRyxFQUFFLENBQ0gsSUFBSSxDQUFDLGtCQUFrQjtTQUNwQixNQUFNLENBQUMsVUFBVSxDQUFDLEVBQUU7UUFDbkIsSUFBSSxTQUFTLElBQUksVUFBVSxDQUFDLFNBQVMsS0FBSyxTQUFTLEVBQUU7WUFDbkQsT0FBTyxLQUFLLENBQUM7U0FDZDtRQUNELElBQUksV0FBVyxJQUFJLFVBQVUsQ0FBQyxXQUFXLEtBQUssV0FBVyxFQUFFO1lBQ3pELE9BQU8sS0FBSyxDQUFDO1NBQ2Q7UUFDRCxJQUNFLGFBQWEsS0FBSyxLQUFLO1lBQ3ZCLFVBQVUsQ0FBQyxNQUFNLEtBQUsscUNBQXVCLENBQUMsTUFBTSxFQUNwRDtZQUNBLE9BQU8sS0FBSyxDQUFDO1NBQ2Q7UUFDRCxJQUNFLGdCQUFnQixLQUFLLEtBQUs7WUFDMUIsVUFBVSxDQUFDLE1BQU0sS0FBSyxxQ0FBdUIsQ0FBQyxTQUFTLEVBQ3ZEO1lBQ0EsT0FBTyxLQUFLLENBQUM7U0FDZDtRQUNELElBQUkscUJBQXFCLEtBQUssS0FBSyxFQUFFO1lBQ25DLE1BQU0sWUFBWSxHQUFHLElBQUEsc0JBQWUsRUFBQyxJQUFJLEVBQUUsVUFBVSxDQUFDLFNBQVMsQ0FBQyxDQUFDO1lBQ2pFLE1BQU0sZUFBZSxHQUFHLElBQUEsaURBQXVCLEVBQzdDLFVBQVUsRUFDVixZQUFZLENBQ2IsQ0FBQyxlQUFlLENBQUM7WUFDbEIsSUFBSSxlQUFlLEtBQUssa0JBQWtCLEVBQUU7Z0JBQzFDLE9BQU8sS0FBSyxDQUFDO2FBQ2Q7U0FDRjtRQUNELE9BQU8sSUFBSSxDQUFDO0lBQ2QsQ0FBQyxDQUFDO1NBQ0QsSUFBSSxDQUNILE9BQU8sQ0FBQyxDQUFDLENBQUMsMkNBQTJCLENBQUMsQ0FBQyxDQUFDLDBDQUEwQixDQUNuRSxFQUNMO1FBQ0UsSUFBSSxDQUFDLGtCQUFrQjtRQUN2QixhQUFhO1FBQ2IscUJBQXFCO1FBQ3JCLGdCQUFnQjtRQUNoQixXQUFXO1FBQ1gsU0FBUztRQUNULE9BQU87S0FDUixDQUNGLENBQUM7SUFFRixPQUFPLGtCQUFrQixDQUFDO0FBQzVCLENBQUM7QUExREQsK0NBMERDIn0=